import React from "react";

import { authContext, clearInteractiveLoginMarker } from "../../services/auth";

const retry = () => {
  clearInteractiveLoginMarker();
  try {
    authContext.login();
  } catch {}
};

const AuthError = () => (
  <div
    style={{
      padding: "1.5rem",
      height: "100vh",
      maxWidth: "70rem",
      display: "flex",
      flexDirection: "column",
      margin: "auto",
      backgroundColor: "#ededed",
    }}
  >
    <h3>You need to sign in again.</h3>
    <h5>
      Your session couldn't be renewed in the background. Private windows,
      Safari's tracking protection, and ad-block or anti-tracking extensions can
      all cause this. You may be redirected to the Microsoft sign-in page
      automatically — if nothing happens, use the button below. If it keeps
      happening, allow login.microsoftonline.com in your browser or extension
      settings.
    </h5>
    <button
      onClick={retry}
      style={{
        alignSelf: "flex-start",
        padding: "0.5rem 1.5rem",
        cursor: "pointer",
      }}
    >
      Sign in
    </button>
  </div>
);

export default AuthError;
